import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import ShortLinkRepository from "../../../repositories/short-link-repository";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import { handleBackendError } from "../../../utils/helpers";
import { ShortLink } from "../../../models/short-link";
import { ShortLinkDataList } from "../list/interface";

export const useGetShortLink = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<ShortLinkDataList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [detailData, setDetailData] = useState<ShortLink | null>(null);
  const [isOnFetchingDetailData, setIsOnFetchingDetailData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await ShortLinkRepository.all(params)
      .then((response: AxiosResponse<ICollection<ShortLinkDataList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);
  
  const loadDetailData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingDetailData(true);
      
      await ShortLinkRepository.show(id, params)
        .then((response: AxiosResponse<IResource<ShortLink>>) => {
          setDetailData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingDetailData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadDetailData,
    isOnFetchingDetailData,
    detailData,
  };
}